import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip classes={{ popper: className }}
    enterTouchDelay={0}      // chạm cái hiện luôn trên mobile
    leaveTouchDelay={3000}  // tooltip tự ẩn sau 3s trên mobile
    {...props}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    fontWeight: "normal",
    borderRadius: 8,
    padding: 12,
    whiteSpace: "pre-line",
  },
}));

export default LightTooltip;